import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { L3OnboardingAssets } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingDropdown } from '../../L3OnboardingDropdown'

import type { L3OnboardingDropdownVariantProps } from '../types'
import type { SelectListItem } from '@circlefin/components/lib/SelectList'

export const assetsSchema = y.mixed<L3OnboardingAssets>()

// Define order of values in dropdown to avoid alphabetically sorted generated GQL enums
const orderedValues = [
  L3OnboardingAssets.from0to10m,
  L3OnboardingAssets.from10mto50m,
  L3OnboardingAssets.from50mto100m,
  L3OnboardingAssets.from100mto500m,
  L3OnboardingAssets.from500mto1b,
  L3OnboardingAssets.over1b,
  L3OnboardingAssets.notApplicable,
]

export const Assets: React.FC<L3OnboardingDropdownVariantProps> = ({
  ...props
}) => {
  const { t } = useTranslation('l3Onboarding')

  const data: Array<SelectListItem<L3OnboardingAssets>> = useMemo(() => {
    return orderedValues.map((option) => ({
      label: t(
        `forms.intendedUseOfAccount.assetsUnderManagement.options.${L3OnboardingAssets[option]}`,
      ),
      value: L3OnboardingAssets[option],
    }))
  }, [t])

  return (
    <L3OnboardingDropdown
      items={data}
      label={t`forms.intendedUseOfAccount.assetsUnderManagement.label`}
      {...props}
    />
  )
}
